import type { CorridorOpportunity } from '~/types/corridorOpportunity';

export function aud(value: number | null): string {
  return value === null ? '—' : `A$${Math.round(value).toLocaleString('en-AU')}`;
}

export function percentage(value: number, fraction = false): string {
  return `${(fraction ? value * 100 : value).toFixed(1)}%`;
}

export function providerName(provider: string): string {
  const providerNames: Record<string, string> = {
    jetstar: 'Jetstar',
    sabre: 'Sabre',
    travelFusion: 'TravelFusion',
  };

  return providerNames[provider] ?? provider;
}

export function isPriceValidationFresh(opportunity: CorridorOpportunity): boolean {
  return !!opportunity.priceValidation && new Date(opportunity.priceValidation.expiresAt).getTime() > Date.now();
}
